import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { style: {"background-color":"#ffffff"} }
const _hoisted_2 = { class: "window" }
const _hoisted_3 = { class: "station-right-div" }
const _hoisted_4 = { style: {"margin-left":"1%"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "station-content" }
const _hoisted_8 = { class: "mb-3 row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "lbl_area",
  class: "col-sm-3 col-form-label",
  style: {"text-align":"right"}
}, "Area", -1 /* HOISTED */)
const _hoisted_10 = { class: "col-sm-5" }
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-3" }, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-3" }, null, -1 /* HOISTED */)
const _hoisted_15 = {
  class: "col-sm-5",
  style: {"text-align":"left","color":"red"}
}
const _hoisted_16 = { class: "mb-3 row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "lbl_country",
  class: "col-sm-3 col-form-label",
  style: {"text-align":"right"}
}, "Country", -1 /* HOISTED */)
const _hoisted_18 = { class: "col-sm-5" }
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-3" }, null, -1 /* HOISTED */)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-3" }, null, -1 /* HOISTED */)
const _hoisted_22 = {
  class: "col-sm-5",
  style: {"text-align":"left","color":"red","margin-top":"3px"}
}
const _hoisted_23 = { class: "mb-3 row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "lbl_comName",
  class: "col-sm-3 col-form-label",
  style: {"text-align":"right"}
}, "Company Name", -1 /* HOISTED */)
const _hoisted_25 = { class: "col-sm-5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-3" }, null, -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-3" }, null, -1 /* HOISTED */)
const _hoisted_28 = {
  class: "col-sm-5",
  style: {"text-align":"left","color":"red","margin-top":"3px"}
}
const _hoisted_29 = { class: "mb-3 row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "lbl_statCode",
  class: "col-sm-3 col-form-label",
  style: {"text-align":"right"}
}, "Station Code", -1 /* HOISTED */)
const _hoisted_31 = { class: "col-sm-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-6" }, null, -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-3" }, null, -1 /* HOISTED */)
const _hoisted_34 = {
  class: "col-sm-5",
  style: {"text-align":"left","color":"red","margin-top":"3px"}
}
const _hoisted_35 = { class: "mb-3 row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "lbl_parentCode",
  class: "col-sm-3 col-form-label",
  style: {"text-align":"right"}
}, "Parent Code", -1 /* HOISTED */)
const _hoisted_37 = { class: "col-sm-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-6" }, null, -1 /* HOISTED */)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-3" }, null, -1 /* HOISTED */)
const _hoisted_40 = {
  class: "col-sm-6",
  style: {"text-align":"left","color":"red","margin-top":"3px"}
}
const _hoisted_41 = { class: "mb-3 row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  for: "lbl_digitCode",
  class: "col-sm-3 col-form-label",
  style: {"text-align":"right"}
}, "Three Digit Code", -1 /* HOISTED */)
const _hoisted_43 = { class: "col-sm-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-6" }, null, -1 /* HOISTED */)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "col-sm-3" }, null, -1 /* HOISTED */)
const _hoisted_46 = {
  class: "col-sm-6",
  style: {"text-align":"left","color":"red","margin-top":"3px"}
}
const _hoisted_47 = { class: "mb-3 row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["Alert"], {
            alertMessage: $setup.alertMessage,
            alertState: $setup.alertState
          }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
        ]),
        ($setup.titleStatus !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode($setup["AdminNavigation"], { menuTile: $setup.title2 }, null, 8 /* PROPS */, ["menuTile"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode($setup["AdminNavigation"], { menuTile: $setup.title1 }, null, 8 /* PROPS */, ["menuTile"])
            ])),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("select", {
                class: "form-select",
                onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.areaChange($event))),
                value: $setup.selectedAreaCode
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.areaInfo, (info, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: info.areaCode
                  }, _toDisplayString(info.area), 9 /* TEXT, PROPS */, _hoisted_12))
                }), 128 /* KEYED_FRAGMENT */))
              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11)
            ]),
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString($setup.areaError), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedCountryCode) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countryInfo, (info, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: info.countryCode
                  }, _toDisplayString(info.country), 9 /* TEXT, PROPS */, _hoisted_19))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.selectedCountryCode]
              ])
            ]),
            _hoisted_20,
            _hoisted_21,
            _createElementVNode("span", _hoisted_22, _toDisplayString($setup.countryError), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                style: {"text-transform":"uppercase"},
                id: "txtComName",
                maxlength: "100",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.CompanyName) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.CompanyName]
              ])
            ]),
            _hoisted_26,
            _hoisted_27,
            _createElementVNode("span", _hoisted_28, _toDisplayString($setup.companyError), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              ($setup.titleStatus == 'Edit')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    class: "form-control",
                    style: {"text-transform":"uppercase"},
                    id: "txtStadCode",
                    maxlength: "4",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.StationCode) = $event)),
                    disabled: ""
                  }, null, 512 /* NEED_PATCH */)), [
                    [_vModelText, $setup.StationCode]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    class: "form-control",
                    style: {"text-transform":"uppercase"},
                    id: "txtStadCode",
                    maxlength: "4",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.StationCode) = $event))
                  }, null, 512 /* NEED_PATCH */)), [
                    [_vModelText, $setup.StationCode]
                  ])
            ]),
            _hoisted_32,
            _hoisted_33,
            _createElementVNode("span", _hoisted_34, _toDisplayString($setup.stationError), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                style: {"text-transform":"uppercase"},
                id: "txtParentCd",
                maxlength: "6",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.ParentCode) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.ParentCode]
              ])
            ]),
            _hoisted_38,
            _hoisted_39,
            _createElementVNode("span", _hoisted_40, _toDisplayString($setup.parentCdError), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                style: {"text-transform":"uppercase"},
                id: "txtDigitCd",
                maxlength: "3",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.ThreeDigit) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.ThreeDigit]
              ])
            ]),
            _hoisted_44,
            _hoisted_45,
            _createElementVNode("span", _hoisted_46, _toDisplayString($setup.threeDigitCdError), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary btnBack",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.backProcess()))
            }, " Back "),
            ($setup.titleStatus == '')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary btnAdd",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.stationAddOrEditProcess('Add')))
                }, " Add "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-primary btnAdd",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.stationAddOrEditProcess('Edit')))
                }, " Update "))
          ])
        ])
      ])
    ])
  ]))
}